import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import "semantic-ui-css/semantic.min.css";
import HomePage from "./component/homePage";
import DramaBooks from "./component/dramaBooks";
import HumorBooks from "./component/humorBooks";
import Books from "./component/books";
import PoliticsBooks from "./component/politcsBooks";
import PhilosophyBooks from "./component/philosophy";
import HistoryBooks from "./component/historyBooks";
import AdventuresBooks from "./component/adventuresBooks";

function App() {
  return (
    <div>
      <Provider store={store}>
        <Router>
          <Switch>
            <Route exact path="/books" component={Books} />
          </Switch>
          <Switch>
            <Route exact path="/" component={HomePage} />
          </Switch>
          <Switch>
            <Route exact path="/dramabooks" component={DramaBooks} />
          </Switch>
          <Switch>
            <Route exact path="/humorbooks" component={HumorBooks} />
          </Switch>
          <Switch>
            <Route exact path="/politcsbooks" component={PoliticsBooks} />
          </Switch>
          <Switch>
            <Route exact path="/philosophybooks" component={PhilosophyBooks} />
          </Switch>
          <Switch>
            <Route exact path="/historybooks" component={HistoryBooks} />
          </Switch>
          <Switch>
            <Route exact path="/adventuresbooks" component={AdventuresBooks} />
          </Switch>
        </Router>
      </Provider>
    </div>
  );
}

export default App;
